var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThSolid = function SvgThSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6v20h26V6Zm2 2h4v4H5Zm6 0h4v4h-4Zm6 0h4v4h-4Zm6 0h4v4h-4ZM5 14h4v4H5Zm6 0h4v4h-4Zm6 0h4v4h-4Zm6 0h4v4h-4ZM5 20h4v4H5Zm6 0h4v4h-4Zm6 0h4v4h-4Zm6 0h4v4h-4Z"
  })));
};
export default SvgThSolid;